import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import { TablaDesarrolloRow } from "../models/tablaDesarrolloRow";
import Conversiones from "../../../../utils/conversiones";
import AccionesTablaDesarrollo from "../components/accionesTablaDesarrollo";

interface IProps{
    isActionable: boolean;
    updateTabla: (id?: number | null) => void;
    deleteTabla: (id?: number | null) => void;
    detalleTabla: (id?: number | null) => void;
}

export default function UseTablaDesarrolloColumns({isActionable, updateTabla, deleteTabla, detalleTabla} : IProps ) {

    const MIN = new Date("0001-01-01T00:00:00");

    const isDateValid = (date: Date) : boolean => {
        return (new Date(date).toString()) !== (new Date(MIN).toString())
    }

    const COLUMNS: columns<TablaDesarrolloRow>[] = [
        {
            name: 'Nombre tabla',
            selector: (row) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true,
            center: false,
        },
        {
            name: 'Tasa emisión',
            selector: (row: TablaDesarrolloRow) => (row.tasaanual),
            cell: (row) => numericFormatter(row.tasaanual!.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'tasaanual',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Plazo crédito',
            selector: (row: TablaDesarrolloRow) => (row.plazoanual),
            sortable: true,
            sortField: 'plazoanual',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Periodo gracia',
            selector: (row) => row.periodosgraciacapital,
            sortable: true,
            sortField: 'periodosgraciacapital',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Periodo gracia K+I',
            selector: (row) => row.periodosgraciacapitalintereses,
            sortable: true,
            sortField: 'periodosgraciacapitalintereses',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Fecha protocolización',
            selector: (row: TablaDesarrolloRow) => row.fechaprotocolizacion && isDateValid(row.fechaprotocolizacion) ?
                Conversiones.formatDate(new Date(row.fechaprotocolizacion)) : '',
            sortable: true,
            sortField: 'fechaprotocolizacion',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Número protocolización',
            selector: (row) => row.numeroprotocolizacion,
            sortable: true,
            sortField: 'numeroprotocolizacion',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Base tasa',
            selector: (row) => row.basetasa ? row.basetasa : "360",
            sortable: true,
            sortField: 'basetasa',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Fecha escrituración',
            selector: (row: TablaDesarrolloRow) => row.fechaescrituracion && isDateValid(row.fechaescrituracion) ?
                Conversiones.formatDate(new Date(row.fechaescrituracion)) : '',
            sortable: true,
            sortField: 'fechaescrituracion',
            wrap: true,
            export: true,
            center: true,
        }
    ];

    if (isActionable){
        COLUMNS.unshift({
            name: "Acciones",
            selector: (row: TablaDesarrolloRow) => row.id,
            cell: (row: TablaDesarrolloRow) => 
                <AccionesTablaDesarrollo
                    onUpdate={() => updateTabla(row.id)}
                    onDelete={() => deleteTabla(row.id)}
                    onVerDetalle={() => detalleTabla(row.id)}
                />,
            sortable: true,
            sortField: 'id',
            wrap: true,
            export: false,
            center: true,
        })
    }

    return { COLUMNS };
}